module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.migrateStatusTitle,
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "migrateStatusInfo",
    attrs: {
      "model": _vm.migrateStatusInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "迁移量"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("总共 : " + _vm._s(_vm.migrateStatusInfo.totalCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "success"
    }
  }, [_vm._v("成功 : " + _vm._s(_vm.migrateStatusInfo.successCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("失败 : " + _vm._s(_vm.migrateStatusInfo.failCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("忽略 : " + _vm._s(_vm.migrateStatusInfo.ignoreCount))]), _vm._v(" "), _c('el-tag', {
    staticClass: "form-tags",
    attrs: {
      "type": ""
    }
  }, [_vm._v("未做 : " + _vm._s(_vm.migrateStatusInfo.unDoCount))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "正在迁移"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "readonly": ""
    },
    model: {
      value: (_vm.migrateStatusInfo.moving),
      callback: function($$v) {
        _vm.$set(_vm.migrateStatusInfo, "moving", $$v)
      },
      expression: "migrateStatusInfo.moving"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('div', [_vm._v("注：忽略的域，指该域已经处于目标集群")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.migrateStatusInfo.finished
    },
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("完成")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-719b56be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/migrate_status_dialog.vue
// module id = 1421
// module chunks = 1